import { render } from "./ButtonListNetflix.vue?vue&type=template&id=5b546a14&scoped=true&ts=true"
import script from "./ButtonListNetflix.vue?vue&type=script&lang=ts"
export * from "./ButtonListNetflix.vue?vue&type=script&lang=ts"

import "./ButtonListNetflix.vue?vue&type=style&index=0&id=5b546a14&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b546a14"]])

export default __exports__